import { isValidEmail, isValidTelefone } from '@/shared/utils/contato';

import type {
  CanalAcessoParte,
  ContatoPendenteMascarado,
  ParteCompletaItem,
  ReenviarLinkAcessoResultado,
  TipoEnvioAcesso,
  VerificacaoFacialParteInput,
} from '@/features/secretaria-arbitral/types';

import { justificativaValida } from './partesEscrita';

export const AVISO_TITULARIDADE_CPF_CNPJ =
  'O contato informado precisa pertencer ao titular do CPF/CNPJ cadastrado na parte. A verificação facial confere a titularidade antes de qualquer troca.';

export const AVISO_TROCA_APOS_VERIFICACAO =
  'A troca só é aplicada depois que a parte concluir a verificação e ela for aprovada. Até lá, o contato atual continua valendo.';

export const CANAL_ACESSO_LABEL: Record<CanalAcessoParte, string> = {
  EMAIL: 'E-mail',
  WHATSAPP: 'WhatsApp',
};

const TIPO_ENVIO_ACESSO_LABEL: Record<TipoEnvioAcesso, string> = {
  LINK_CITACAO: 'Link de citação',
  MAGIC_LINK: 'Magic link de login',
};

const STATUS_PARTE_ATIVO = 'ATIVO';
const STATUS_PARTE_INATIVO = 'INATIVO';

export interface VerificacaoFacialFormValores {
  novoEmail: string;
  novoTelefone: string;
  motivo: string;
}

export const VERIFICACAO_FACIAL_FORM_VAZIA: VerificacaoFacialFormValores = {
  novoEmail: '',
  novoTelefone: '',
  motivo: '',
};

export function canaisDisponiveisDaParte(parte: ParteCompletaItem): CanalAcessoParte[] {
  const canais: CanalAcessoParte[] = [];
  if (parte.emails.length > 0) canais.push('EMAIL');
  if (parte.telefones.length > 0) canais.push('WHATSAPP');
  return canais;
}

export function parteEstaAtiva(parte: ParteCompletaItem): boolean {
  const status = parte.detalheArbitral?.statusParte;
  return status === undefined || status === null || status === STATUS_PARTE_ATIVO;
}

export function parteEstaInativa(parte: ParteCompletaItem): boolean {
  return parte.detalheArbitral?.statusParte === STATUS_PARTE_INATIVO;
}

export function parteVerificavelPorFacial(parte: ParteCompletaItem): boolean {
  return parte.pessoa.tipoPessoa === 'FISICA' && parte.pessoa.cpfCnpj.trim().length > 0;
}

export function podeSolicitarVerificacaoFacial(valores: VerificacaoFacialFormValores): boolean {
  const email = valores.novoEmail.trim();
  const telefone = valores.novoTelefone.trim();
  if (email.length === 0 && telefone.length === 0) return false;
  if (email.length > 0 && !isValidEmail(email)) return false;
  if (telefone.length > 0 && !isValidTelefone(telefone)) return false;
  return justificativaValida(valores.motivo);
}

export function montarVerificacaoFacialPayload(
  valores: VerificacaoFacialFormValores,
): VerificacaoFacialParteInput {
  const email = valores.novoEmail.trim().toLowerCase();
  const telefone = valores.novoTelefone.trim();
  return {
    motivo: valores.motivo.trim(),
    ...(email.length > 0 ? { novoEmail: email } : {}),
    ...(telefone.length > 0 ? { novoTelefone: telefone } : {}),
  };
}

export function descreverReenvioDeAcesso(resultado: ReenviarLinkAcessoResultado): string {
  const canal = CANAL_ACESSO_LABEL[resultado.canal];
  const tipo = TIPO_ENVIO_ACESSO_LABEL[resultado.tipoEnvio];
  return `${tipo} enviado por ${canal} para ${resultado.destinoMascarado}.`;
}

export function descreverContatoPendente(contato: ContatoPendenteMascarado): string {
  const partes: string[] = [];
  if (contato.emailMascarado) partes.push(`e-mail ${contato.emailMascarado}`);
  if (contato.telefoneMascarado) partes.push(`WhatsApp ${contato.telefoneMascarado}`);
  return partes.length > 0 ? partes.join(' e ') : 'nenhum contato informado';
}
